import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setUser } from "./session-slice";
import { authService } from "../../commons";
import { User } from "../../commons/models/user";
import { IAuthState } from "../interfaces/i-auth-state";
import { StatusEnum } from "../../commons/enums/status-enum";
import ability from "../../casl/Can";
import {buildAbilityFor} from "../../casl/ability";

const initialState: IAuthState = {
  user: new User(),
  userStatus: StatusEnum.Idle,
};

export const authUserProfile = createAsyncThunk("authMe", async (_, thunkAPI) => {
  try {
    const user = await authService.getAuthUser();
    ability.update(buildAbilityFor(user).rules);
    thunkAPI.dispatch(setUser(new User().create(user) as User));
    return user;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

const authMeSlice = createSlice({
  name: "auth-me",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(authUserProfile.pending, (state) => {
        state.userStatus = StatusEnum.Loading;
      })
      .addCase(authUserProfile.fulfilled, (state, action) => {
        state.userStatus = StatusEnum.Succeeded;
        state.user = new User().create(action.payload) as User;
      })
      .addCase(authUserProfile.rejected, (state) => {
        state.userStatus = StatusEnum.Failed;
      });
  },
});

export default authMeSlice.reducer;
